import React, { Component } from 'react'

class GoogleMap extends Component {
  render() {
    return (
      // Important! Always set the container height explicitly
      <div style={{ flexBasis: '60%' }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2309.994284064146!2d39.755361315638886!3d54.62170798026605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTTCsDM3JzE4LjIiTiAzOcKwNDUnMjcuMiJF!5e0!3m2!1sfr!2sfr!4v1618855966935!5m2!1sfr!2sfr"
          width="100%"
          height="450"
          frameBorder="0"
          aria-hidden="false"
          title="googleMap"
        ></iframe>
      </div>
    )
  }
}

export default GoogleMap
